/* istanbul ignore file */
export * from './CategoryFilterStandalone';
